import { call } from 'redux-saga/effects'
import { getProjectUpdatedAt } from 'sagas/setupProjectsSaga/findBySelector'
import mostRecentUpdatedAt from 'sagas/setupProjectsSaga/mostRecentUpdatedAt'
import getDocument from 'helpers/databases/getDocument'
import isEmpty from 'ramda/src/isEmpty'

export function * getMostRecentId(db) {
  const projects = yield call(getProjectUpdatedAt, db)
  if (isEmpty(projects)) return { projects: [], _id: null }
  const updatedAt = mostRecentUpdatedAt(projects)
  const { _id } = projects.find(p => p.updatedAt === updatedAt)
  return { _id, projects }
}

function * mostRecentProject(db) {
  const { _id, projects } = yield call(getMostRecentId, db)
  if (isEmpty(projects)) return { project: null, projectsLength: 0 }
  const project = yield call(getDocument, db, _id)
  return { project, projectsLength: projects.length }
}

export default mostRecentProject



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/mostRecentProject.js